import ModalImage from "react-modal-image"
import RogSuccessToolTip from "../../component/rogSuccessTooltip"
import { RetailerColumnNames } from "../../constants"
import ImageTagsDetails from "../SocialTrendsTags/ImageTagsDetails"
import Collection from "../V2Leaderboard/Collection"

const Image = ({ image, trendType, allCollectionNames, addImageToCollection, collectionSets, isMainPage = false, fetchCollections }) => {
  return <div className={`w-1/2 p-2 border border-slate-300 h-[${isMainPage ? '19' : '21'}rem] overflow-visible`}>
    <div className="flex justify-center items-center relative group">
      <div className="relative group " >
        <Collection image={image} collections={allCollectionNames} addImageToCollection={addImageToCollection} collectionSets={collectionSets} fetchCollections={fetchCollections} />
        <div data-tooltip-id={'trends-tooltip-' + (trendType == 'social' ? image.mediaId : image.pk)}>
          <ModalImage
            small={image[trendType == 'social' ? 'imageUrl' : 'image_url']}
            large={image[trendType == 'social' ? 'imageUrl' : 'image_url']}
            className='h-[16rem]'
          />
        </div>
      </div>
    </div>
    {trendType == 'social' ? <div className="px-3 text-xs">
      <a href={`${image.postUrl}`} className='text-blue-600 font-medium' target='_blank'>{image.username}</a>
      <p>{new Date(image.timeStamp).toDateString()}</p>
      <ImageTagsDetails mediaId={image.mediaId} />
    </div> : <div className="px-3 text-xs">
      {['sales', 'reviews', 'bestsellerRank', 'retailerHashtag'].map(item => <div key={item} hidden={!image[item]} className=' max-w-40 text-[12px] font-normal'><span className="font-semibold">{RetailerColumnNames[item]}: </span>{image[item]}</div>)}
      <a href={`${image.product_url}`} className='text-blue-600 font-medium' target='_blank'>{image.retailer}</a>
      {['price', 'title'].map(item => <div key={item} hidden={!image[item]} className={`${item == 'title' ? 'text-nowrap overflow-hidden' : ''} max-w-40 text-[12px]`}><span className="font-semibold">{RetailerColumnNames[item]}: </span>{item == 'title' ? image[item].slice(0, 20) : image[item]}</div>)}
      <ImageTagsDetails mediaId={image.pk} isretailer={true} />
    </div>}

  </div>


}


export default Image
